import { Company } from "./Company";

export class User {
    iduser: number;
    name: string;
    surname: string;
    email: string;
    password: string;
    role: number;
    phone: string;
    active: boolean;
    createdAt: Date;
    last_conection: Date;
    company: Company;
    company_str: string;
    numberOfConnections: number;
    user_rol: number;
    language: number;

    constructor() {
        // Asigna valores por defecto a las propiedades
        this.iduser = 0;
        this.name = '';
        this.surname = '';
        this.email = '';
        this.password = '';
        this.role = 0;
        this.phone = '';
        this.active = true;
        this.company = new Company();
        this.company_str = '';
        this.numberOfConnections = 0;
        this.user_rol = 0;
        this.language = 1;
        this.createdAt = new Date();
        this.last_conection = new Date();
    }
}